import { useEffect, useState } from "react"; 
import SearchIcon from "../assets/icons/search.svg";
import CalenderIcon from "../assets/icons/calender.svg";
import UserIcon from "../assets/icons/user.svg";
import TagIconSecondary from "../assets/icons/tag-icon.svg";
import BusinessIcon from "../assets/icons/bussiness-icon.svg";
import ConsultingIcon from "../assets/icons/consulting-icon.svg";
import UIUXDesignIcon from "../assets/icons/ui-ux-icon.svg";
import ITServicesIcon from "../assets/icons/it-service-icon.svg";
import LogisticsIcon from "../assets/icons/logistics-icon.svg";
import CaseStudyIcon from "../assets/icons/case-study-icon.svg";
import DefaultIcon from "../assets/icons/bussiness-icon.svg";
import backBtn from "../assets/icons/back-btn.svg";
import { useParams, useNavigate } from "react-router-dom";
import "../BlogDetail.css";

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const BlogLanding = () => {

  
    const [form, setForm] = useState({ name: "", message: "" });
    const { slug } = useParams();
    const navigate = useNavigate();
    const [post, setPost] = useState(null);
    const [categories, setCategories] = useState([]);
    const [recentposts, setRecentPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    const [searchQuery, setSearchQuery] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);

    const categoryIcons = {
      1: BusinessIcon,
      2: ConsultingIcon,
      4: UIUXDesignIcon,
      27: ITServicesIcon,
      28: LogisticsIcon,
      46: CaseStudyIcon,
    };

    // fetch recent posts
    const fetchRecentPosts = async () => {
      const res = await fetch(
        "https://blog.lentera.in/wp-json/wp/v2/posts?per_page=5&orderby=date&order=desc&_fields=id,slug,title"
      );
      const data = await res.json();
      setRecentPosts(data);
    };
    // Fetch Categories
    const fetchCategories = async () => {
      const res = await fetch(
        "https://blog.lentera.in/wp-json/wp/v2/categories?_fields=id,name,slug,count"
      );
      const data = await res.json();

      const filtered = data.filter(cat => cat.count > 0);
      
      setCategories(filtered);
    };

    useEffect(() => {
      fetchCategories();
      fetchRecentPosts();
    }, []);

    useEffect(() => {
      const fetchPost = async () => {
        try {
          setLoading(true);
          const res = await fetch(
            `https://blog.lentera.in/wp-json/wp/v2/posts?slug=${slug}&_embed`
          );
          const data = await res.json();

          if (!Array.isArray(data) || data.length === 0) {
            setPost(false);
            setLoading(false);
            return;
          }

          setPost(data[0]);
          console.log(post);
          setLoading(false);

        } catch (err) {
          setPost(false);
          setLoading(false);
        }
      };

      fetchPost();
    }, [slug]);

    useEffect(() => {
      if (!searchQuery) {
        setSuggestions([]);
        return;
      }

      const delay = setTimeout(() => {
        fetchSearchSuggestions();
      }, 400);

      return () => clearTimeout(delay);
    }, [searchQuery]);


    const fetchSearchSuggestions = async () => {
      try {
        setSearchLoading(true);

        const res = await fetch(
          `https://blog.lentera.in/wp-json/wp/v2/posts?search=${searchQuery}&per_page=6&_fields=id,slug,title.rendered`
        );
        const data = await res.json();

        const matched = data.filter(post =>
          post.title.rendered.toLowerCase().includes(searchQuery.toLowerCase())
        );

        setSuggestions(matched.slice(0, 6));
      } catch (err) {
        setSuggestions([]);
      } finally {
        setSearchLoading(false);
      }
    };

  if (loading) {
    return (
      <div className="fixed inset-0 flex justify-center items-center bg-black/20 backdrop-brightness-90 z-50">
        <div className="w-10 h-10 border-4 border-gray-300 border-t-green-600 rounded-full animate-spin"></div>
      </div>
    );
  }

  if (post === false) {
    return (
      <div className="flex justify-center items-center h-[50vh]">
        <p className="text-green-700 text-xl font-semibold">Post Not Found</p>
      </div>
    );
  }


  const featuredImage = post._embedded?.["wp:featuredmedia"]?.[0]?.source_url;
  const postedOn = new Date(post.date).toLocaleDateString();
  const category = post._embedded?.["wp:term"]?.[0]?.[0]?.name;
  const author = post._embedded?.author?.[0]?.name;


  // Remove Elementor <style> tags if needed
  const content = post.content.rendered.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "").replace(/ style="[^"]*"/gi, "");

  return (
    <>

      <Helmet>
        <title>{post?.title?.rendered || "Loading..."}</title>
        <meta name="description" content="Explore expert insights on AI, automation, machine learning, chatbots, software development, and digital innovation. Stay updated with the latest trends, strategies, and industry perspectives from Lentera Technologies.."/>
        <meta name="keywords" content=" AI blog, technology blog, machine learning insights, automation trends, software development articles, chatbot technology, digital innovation, AI solutions, tech updates, Lentera Technologies blog"/>
      </Helmet>

       <div className="sticky top-20 z-40 pointer-cursor">
          <div className="relative w-full h-0">
            <Link
              to="/blogs"
              className="absolute left-1 p-1 md:p-3"
            >
              <img src={backBtn} className="w-4 h-4 md:w-5 h-5" />
            </Link>
          </div>
        </div>

      <div className="bg-white px-4 sm:px-6 md:px-10 lg:px-12 xl:px-16 py-8 md:py-10">
      
        {/* MAIN GRID */}
        <div className="grid grid-cols-1 lg:grid-cols-[9fr_3fr] gap-8">

          {/* LEFT CONTENT */}
          <div className="blog-container bg-[#FBFBFB] border border-[#EFEFEF] rounded-lg p-4 sm:p-6 mb-6">

            <h1
              className="text-[#212129] font-semibold text-2xl sm:text-3xl md:text-[36px] mb-4 leading-snug"
              dangerouslySetInnerHTML={{ __html: post.title.rendered }}
            />

            {/* META INFO */}
            <div className="flex flex-wrap items-center gap-4 mb-8">

              {/* Date */}
              <div className="relative flex items-center">
                <img
                  src={CalenderIcon}
                  alt="calendar"
                  className="absolute left-0 top-1/2 -translate-y-1/2 w-5 h-5"
                />
                <span className="ml-7 text-sm font-medium leading-[24px] text-[#979797]">
                  {postedOn}
                </span>
              </div>

              {/* Separator */}
              <span className="hidden sm:block w-px h-6 bg-[#CED5DD]"></span>

              {/* Category */}
              <div className="relative flex items-center">
                <img
                  src={TagIconSecondary}
                  alt="user"
                  className="absolute left-0 top-1/2 -translate-y-1/2 w-5 h-5"
                />
                <span className="ml-7 text-sm font-medium leading-[24px] text-[#979797]">
                  {category}
                </span>
              </div>

              {/* Separator */}
              <span className="hidden sm:block w-px h-6 bg-[#CED5DD]"></span>

              {/* Author */}
              <div className="relative flex items-center">
                <img
                  src={UserIcon}
                  alt="tag"
                  className="absolute left-0 top-1/2 -translate-y-1/2 w-5 h-5"
                />
                <span className="ml-7 text-sm font-medium leading-[24px] text-[#979797]">
                  By {author}
                </span>
              </div>
            </div>

            {/* FEATURED IMAGE */}
            <div className="mb-8">
              <img
                src={featuredImage}
                alt={post.title.rendered}
                className="w-full rounded-md object-cover"
              />
            </div>

            {/* BLOG CONTENT */}
            <div
              className="blog-content"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </div>

          {/* RIGHT SIDEBAR */}
          <div className="space-y-6">

            {/* SEARCH BOX */}
            <div className="p-4 border border-[#E5E5E5] rounded-lg">
              <h2 className="text-[#212129] font-semibold text-base uppercase mb-2">Search blogs</h2>

              <div className="relative w-full">
                <img
                  src={SearchIcon}
                  alt="search"
                  className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 opacity-70"
                />

                <input
                  type="text"
                  placeholder="Search blog title..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full border border-gray-300 rounded-xl pl-12 pr-4 py-2 focus:outline-none focus:ring-2 focus:ring-green-600"
                />
              </div>
              {searchQuery && (
                <div className="w-full mt-2 bg-white border border-[#E5E5E5] rounded-lg shadow-md z-50 p-2">

                  {searchLoading && (
                    <div className="p-3 text-sm text-gray-500 text-center">Searching…</div>
                  )}

                  {!searchLoading && suggestions.length === 0 && (
                    <div className="p-3 text-sm text-gray-500 text-center">No results found</div>
                  )}

                  {!searchLoading &&
                    suggestions.map((item) => (
                      <div
                        key={item.id}
                        className="p-3 bg-[#F9F9F9] rounded-lg mb-2 cursor-pointer hover:bg-[#F1F1F1]"
                        onClick={() => {
                          navigate(`/blog/${item.slug}`);
                          setSearchQuery("");
                          setSuggestions([]);
                        }}
                      >
                        <span
                          className="text-[#212129] font-medium text-sm leading-snug opacity-80"
                          dangerouslySetInnerHTML={{ __html: item.title.rendered }}
                        />
                      </div>
                    ))}
                </div>
              )}

            </div>

            {/* RECENT POSTS */}
            <div className="p-4 border border-[#E5E5E5] rounded-lg">
              <h2 className="text-[#212129] font-semibold text-base uppercase mb-3">Recent blogs</h2>

              <div>
                {recentposts.map((post) => (
                  <div className="p-3 bg-[#F9F9F9] rounded-lg mb-3 cursor-pointer" onClick={() => { navigate(`/blog/${post.slug}`); }}>
                    <span
                      className="text-[#212129] font-medium text-sm leading-snug opacity-80"
                      dangerouslySetInnerHTML={{ __html: post.title.rendered }}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* CATEGORIES */}
            <div className="p-4 border border-[#E5E5E5] rounded-lg">
              <h2 className="text-[#212129] font-semibold text-base uppercase mb-3">Categories</h2>

              {categories.map((cat) => (
                <Link to={`/blogs/category/${cat.slug}`} key={cat.id}>
                  <div className="bg-[#F9F9F9] rounded-lg p-3 flex justify-between items-center mb-3">
                    <div className="relative">
                      <img
                        src={categoryIcons[cat.id] || DefaultIcon}
                        alt={cat.name}
                        className="absolute left-0 top-1/2 -translate-y-1/2 w-6 h-6"
                      />
                      <span className="pl-8 text-sm font-medium opacity-80">{cat.name}</span>
                    </div>
                    <span className="text-sm font-medium opacity-80">{cat.count}</span>
                  </div>
                </Link>
              ))}
            </div>

          </div>
        </div>


        {/* COMMENTS SECTION */}
       {/* <div className="grid grid-cols-1 lg:grid-cols-[9fr_3fr] gap-8 mt-10">
          <div className="bg-[#FBFBFB] p-4 sm:p-6 rounded-lg border border-[#EFEFEF]">

            <h1 className="text-2xl sm:text-3xl md:text-[32px] mb-3 font-semibold text-[#212129]">
              Comments
            </h1>

            <p className="text-sm text-[#212129] opacity-50 mb-8">
              Required fields are marked with <span className="text-red-700">*</span>
            </p>

            <form onSubmit={handleSubmit}>
              
              <div className="mb-6">
                <label className="text-[#21272CBF] font-medium text-sm uppercase">
                  Add your comment
                </label>
                <span className="text-red-700">*</span>

                <textarea
                  name="comment"
                  rows="6"
                  className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none resize-none"
                ></textarea>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 mb-6">
                <div>
                  <label className="text-[#21272CBF] font-medium text-sm uppercase">
                    Name
                  </label>
                  <span className="text-red-700">*</span>

                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none"
                  />
                </div>

                <div>
                  <label className="text-[#21272CBF] font-medium text-sm uppercase">
                    Email
                  </label>
                  <span className="text-red-700">*</span>

                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none"
                  />
                </div>
              </div>

              <div className="flex items-start space-x-3 p-3 mb-6">
                <input
                  type="checkbox"
                  id="agree"
                  checked={form.agree}
                  onChange={(e) => setForm({ ...form, agree: e.target.checked })}
                  className="w-4 h-4"
                />

                <label htmlFor="agree" className="text-sm text-[#212129] opacity-70">
                  Save my name, email, and website in this browser for the next time I comment.
                </label>
              </div>

              <button className="bg-green-700 text-white font-bold text-base px-10 py-3 rounded-lg">
                Post comment
              </button>
            </form>
          </div>
        </div> */}

      </div>

    </>
  );
};

export default BlogLanding;
